import React from "react";

const ASP_Syntax = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Syntax</h1>
      <p>This is the ASP Syntax page content.</p>
    </div>
  );
};

export default ASP_Syntax;
